"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noteMethods = void 0;
var noteMethods;
(function (noteMethods) {
    noteMethods["SMS"] = "sms";
    noteMethods["EMAIL"] = "email";
    noteMethods["CALL"] = "call";
    noteMethods["CHAT"] = "chat";
    noteMethods["SYSTEM"] = "system";
    noteMethods["FEEDBACK"] = "feedback";
    noteMethods["COMPLAINTS"] = "complaints";
    noteMethods["APP_REVIEW"] = "appReview";
    noteMethods["OTHER"] = "other";
    noteMethods["KIT"] = "kit";
})(noteMethods || (exports.noteMethods = noteMethods = {}));
